import { render, staticRenderFns } from "./ExportCompta.vue?vue&type=template&id=6ff7e3a0"
import script from "./ExportCompta.vue?vue&type=script&lang=js"
export * from "./ExportCompta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports